export const SUBSCRIPTION_ONBOARDING_LABELS = Object.freeze({
  activationTitle: "Activate your hub subscription",
  activationDescription:
    "Start the available trial or select a paid plan to continue using ZiniHub.",
  trialAvailable: (days) => `Activate ${days}-day free trial`,
  activateFreeTrial: "Activate free trial",
  trialUnavailable:
    "The free trial has already been used for this account. Select a paid plan to continue.",
  trialBannerExplore: "Explore all essential features",
  trialBannerNoCard: "No credit card required",
  trialBannerUpgrade: "Upgrade anytime",
  trialBannerSubtitle: (days) => `${days}-day free trial`,
  reviewTrialSelection: (planName, days) => `You selected TRIAL ${planName} Plan (${days}-day trial)`,
  reviewPaidSelection: (planName, cycleLabel, price) => `You selected ${planName} Plan (${cycleLabel}) — ${price}`,
  reviewNoPayment: "No payment required",
  reviewFullAccess: (planName) => `Full access to ${planName} features`,
  reviewTrialDuration: (days) => `${days} days of free trial`,
  reviewUpgradeAnytime: "Upgrade anytime",
  activatingTrial: "Activating trial...",
  subscribe: "Continue to payment",
  noPaidPlans: "No paid plans are currently available.",
  staffReadOnly:
    "Only the hub owner can activate, renew, upgrade, downgrade, or cancel this subscription.",
});
